import getBlobDuration from 'get-blob-duration';
import { storageApi } from '~api';

export default async filename => getBlobDuration(await storageApi.retrieveRecording(filename));
